import { labelForUnlistedField } from "utils/clientDetailsFormConfig";

const valueForField = (field, stored) => {
  if (field.type === "checkbox-group") {
    if (Array.isArray(stored)) return stored;
    return stored ? [stored] : [];
  }
  return stored === undefined || stored === null ? "" : String(stored);
};

/** Every field the form lists, empty ones included: the save replaces the record's answers. */
export const buildFormValues = (fields, stored = {}) =>
  fields.reduce((acc, field) => {
    if (!field?.id) return acc;
    acc[field.id] = valueForField(field, stored[field.id]);
    return acc;
  }, {});

/**
 * Answers held under a field the form no longer lists: a custom field, or one an admin has since
 * removed or switched off. They stay on the record, so they have to stay on the screen, otherwise
 * saving the form would quietly drop them.
 */
export const unlistedAnswers = (fields, stored = {}) => {
  const listed = new Set(fields.map((field) => field.id));
  return Object.keys(stored)
    .filter((key) => !listed.has(key))
    .sort()
    .map((key) => ({
      key,
      label: labelForUnlistedField(key),
      wasList: Array.isArray(stored[key]),
      value: Array.isArray(stored[key]) ? stored[key].join(", ") : String(stored[key] ?? ""),
    }));
};

export const mergeUnlistedAnswers = (values, extras = []) =>
  extras.reduce(
    (acc, item) => ({
      ...acc,
      [item.key]: item.wasList
        ? item.value
            .split(",")
            .map((part) => part.trim())
            .filter(Boolean)
        : item.value,
    }),
    { ...values }
  );
